const Cookies = function() {}

const GOOGLE_ANALYTICS = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    ga('create', 'UA-85025275-1', 'auto');
    ga('send', 'pageview');`

const TEMPLATE = `<div class="inner">
        <p>This site wants to use cookies from Google services to anonymously analyze traffic.</p>
        <p><button id="acceptcookies">ALLOW COOKIES</button> <button id="rejectcookies">CONTINUE WITHOUT</button></p>
    </div>`

Cookies.prototype.startGA = function() {
    console.log('starting ga...');

    const el = document.querySelector('.cookieplaceholder');
    if (el) {
        const script = document.createElement('script')
        script.innerText = GOOGLE_ANALYTICS;
        el.appendChild(script)
    }
}

Cookies.prototype.getSetting = function() {
    const cb = localStorage.getItem('cookiemonster')
    return cb
}

Cookies.prototype.saveSetting = function(allow) {
    localStorage.setItem('cookiemonster', allow ? 'yes' : 'no')
}

Cookies.prototype.delayedCheck = function() {
    const savedSetting = this.getSetting()
    if (savedSetting) {
        // we have a preference already...
        if (savedSetting === 'yes') {
            // launch GA!
            this.startGA()
        } else {
            console.log('user opted out.')
        }
        return
    }

    const el = document.querySelector('.cookieplaceholder');
    if (el) {
        el.innerHTML = TEMPLATE;

        el.querySelector('#acceptcookies').addEventListener('click', () => {
            el.classList.remove('visible')
            this.saveSetting(true)
            this.startGA()
        });

        el.querySelector('#rejectcookies').addEventListener('click', () => {
            el.classList.remove('visible')
            this.saveSetting(false)
        });

        setTimeout(() => {
            el.classList.add('visible')
        }, 1000)
    }
}

Cookies.prototype.init = function() {
    console.log('initialize cookie monster.');
    setTimeout(() => this.delayedCheck(), 1000);
}

module.exports = Cookies;
